import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthUtils } from '../utils/auth';
import { loginPath } from '../constants/paths';

interface AuthGuardProps {
  children: ReactNode;
}

/**
 * 路由守卫组件
 * 检查用户登录状态，未登录则跳转到登录页
 */
const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const location = useLocation();
  const isLoggedIn = AuthUtils.isLoggedIn();

  if (!isLoggedIn) {
    // 未登录，跳转到登录页，并保存当前路径用于登录后重定向
    const redirect = location.pathname + location.search;
    return <Navigate to={`${loginPath}?redirect=${encodeURIComponent(redirect)}`} replace />;
  }

  // 已登录，渲染子组件
  return <>{children}</>;
};

export default AuthGuard;
